import * as React from 'react';
export const cursorSvg = React.forwardRef(function cursorSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F5F6F8',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M15.898 30.436v-14l-12.124 7 12.124 7Z',
      fill: '#939393',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm28.023 9.436-12.125 21v-14l12.125-7Z',
      fill: '#E3E3E3',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M3.774 9.436h24.248l-12.124 7-12.124-7Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M15.898 2.436v7h12.125l-12.125-7Z',
      fill: '#444',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M3.774 9.436h12.124v-7l-12.124 7Zm24.249 14-6.063-3.5-6.062 10.5 12.125-7Z',
      fill: '#939393',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm28.023 9.436-6.063 10.5 6.063 3.5v-14Zm-12.125 7-12.124 7v-14l12.124 7Z',
      fill: '#444',
    }),
  );
});
cursorSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var cursor = {
  category: 'brand',
  colorable: false,
  name: 'cursor',
  svg: cursorSvg,
};
